import { FC, ReactNode } from 'react'
import { StyleSheet, View } from 'react-native'

interface TabsProps {
    children: ReactNode
}

const Tabs: FC<TabsProps> = ({ children }) => {
    return <View style={styles.container}>{children}</View>
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        backgroundColor: '#FFFFFF',
        height: 60,
    },
})

export default Tabs
